module.exports = __webpack_public_path__ + "img/img9.523933f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img9.jpg
// module id = 345
// module chunks = 0